import '@ids/style-loader';
import '@ids/style-error-message';

import { useState } from 'react';

import type { Action, Content, PurchaseAction } from '../../global-types/Content';
import { useHandleActionClick } from '../../hooks/useHandleActionClick';
import Button from '../button/Button';
import { IdsIcon } from '../icon/Icon';

type ButtonActionProps = {
  action: Action;
  dispatchActionEvent: (action: Action, nextContent?: Content | null) => void;
  validateAction?: (action: Action) => boolean;
  setDisabled: (disabled: boolean) => void;
  disabled: boolean;
};

function ButtonAction({ action, dispatchActionEvent, validateAction, disabled, setDisabled }: ButtonActionProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const { handleActionClick } = useHandleActionClick(dispatchActionEvent);

  async function handleOnClick(action: Action) {
    if (loading || disabled) return;
    if (validateAction && !validateAction(action)) return;

    let hasError = false;

    setDisabled(true);
    setLoading(true);
    setError(false);

    try {
      await handleActionClick(action);
    } catch {
      hasError = true;
      setError(true);
    } finally {
      setLoading(false);
      setDisabled(hasError && !!(action as PurchaseAction).purchaseUnhandledErrorMessage);
    }
  }

  return (
    <div className="if flex flex-column flex-center size-w-100p md-max-w-384">
      {error && (action as PurchaseAction).purchaseUnhandledErrorMessage && (
        <span className="if error-message mb-12">{(action as PurchaseAction).purchaseUnhandledErrorMessage}</span>
      )}
      <Button buttonType={action.buttonType} onClick={() => void handleOnClick(action)} disabled={loading || disabled}>
        {action.text}
        {action.icon && <IdsIcon name={action.icon} size={24} />}
        {loading && <span className="if loader dots x-small" />}
      </Button>
    </div>
  );
}

export default ButtonAction;
